import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/build/repo/layouts/auth.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/opt/build/repo/layouts/blank.vue").then(m => m.default || m)),
  canvas: defineAsyncComponent(() => import("/opt/build/repo/layouts/canvas.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  register: defineAsyncComponent(() => import("/opt/build/repo/layouts/register.vue").then(m => m.default || m)),
  settings: defineAsyncComponent(() => import("/opt/build/repo/layouts/settings.vue").then(m => m.default || m))
}